export class MovimentacaoFinanceira {
  id: number;
  descricao: string;
  valor: number;
  data: Date;
  registroFinanceiroId: number;
  usuarioId: number;
}
